import { Component, OnInit } from '@angular/core';
import { CardBloc } from '@kp/shared/components/cards/card.bloc';
import { CardRequestType, CardScreen } from '@ktypes/enums';
import { Status } from '@ktypes/models';

@Component({
  selector: 'kp-screen-take-action',
  templateUrl: './screen-take-action.component.html',
  styleUrls: ['./screen-take-action.component.scss'],
})
export class ScreenTakeActionComponent implements OnInit {
  cardScreen = CardScreen.category;
  status = Status;
  constructor(public cardBloc: CardBloc) {}

  ngOnInit() {
    // Refresh Take_Action card sets
    this.cardBloc.refresh([CardRequestType.TAKE_ACTION]);
  }
}
